module.exports = __webpack_public_path__ + "media/components/map_controls/ZoomControls/pro-badge-c82c9adeac9fa4593cba891c07686b25.svg";